export const SLICER3 = 'slicer3';
export const CLOUD = 'cloud';
export const MAKERBOT = 'mbot';

export function getList() {
  return [SLICER3, CLOUD, MAKERBOT];
}

export function getId(slicerType) {
  switch (slicerType) {
    case SLICER3: return 51;
    case CLOUD: return 3;
    case MAKERBOT: return 48;
    default: return undefined;
  }
}

export function getName(slicerType) {
  switch (slicerType) {
    case SLICER3: return 'Slicer 3';
    case CLOUD: return 'Cloud Slicer';
    case MAKERBOT: return 'Makerbot Slicer';
    default: return undefined;
  }
}

//Make it global for old apps
window.SLICER_SLICER3 = SLICER3;
window.SLICER_CLOUD = CLOUD;
window.SLICER_MAKERBOT = MAKERBOT;
